import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import React from "react";
import c_next_logo from "../../media/cfirst-claim-4mar26final.png";
import cosentino_logo from "../../media/cnext-cosentino-logo-15jan26.png";
import welcome_c_hall_en from "../../media/cnext-welcome-desktop-2oct25.png";
import welcome_c_hall_es from "../../media/cnext-welcome-desktop-2oct25.png";
import welcome_c_next_mobile from "../../media/cfirst-logo-4mar26.png";
import product_c_next from "../../media/cfirst-logo-4mar26.png";
import triangle from "../../media/Asset11@2x_white.png";
import languageJson from "../../common/language/language";
import Countdown from "react-countdown";
import "./Welcome.scss";
import { languages } from "../../common/constants/languages";

export class Welcome extends React.Component<any, any> {
  timer: any;

  constructor(props: any) {
    super(props);
    this.state = { timeNow: new Date(Date.now()) };
    this.timer = null;
  }

  componentWillMount() {
     this.timer = setInterval(() => { this.setState({ timeNow: new Date(Date.now()) }) }, 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    let language = this.props.match.params.lang;
    const isEnglish = language === languages.en;
    const welcomeLogo = isEnglish ? welcome_c_hall_en : welcome_c_hall_es;
    const productLogo = product_c_next;
    const buttonText =
      isEnglish
        ? languageJson.chall.welcome.button_en
        : languageJson.chall.welcome.button_es;
    const welcomeText = languageJson.chall.welcome.welcome_text;
    const productText = languageJson.chall.welcome.product_text;
    const dateText = isEnglish ? "September 7th - CANTORIA" : "7 Septiembre - CANTORIA";
    const accessEventTime = new Date(`${process.env.REACT_APP_ACCESS_EVENT_DATE}`);
    const dateTime = new Date(`${process.env.REACT_APP_DATE}`);
    const eventOpened = accessEventTime < this.state.timeNow && true;
    eventOpened && clearInterval(this.timer);
    return (
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <div className="welcome">
          <div className="logos">
            <div>
              <img className="logo__c-next" src={c_next_logo} alt="C-Next Logo" />
            </div>
          </div>
          <div className="container">
              <div>
                <img className="logo__welcome" src={welcomeLogo} alt="Welcome Logo" />
                <img className="logo__welcomemobile" src={welcome_c_next_mobile} alt="Welcome Logo" />
                <span className="text__welcome">{welcomeText}</span>
              </div>

              <div>
                <img className="logo__product" src={productLogo} alt="Product Logo" />
              </div>

              <div>
                <span className="text__product">{productText}</span>
              </div>

              <div className="countdown">
                <div className="numbers">
                  <Countdown date={dateTime} daysInHours={true} />
                </div>
              </div>

              <div>
                <img className="logo__cosentino" src={cosentino_logo} alt="Cosentino Logo" />
              </div>

              <button
                 className={`${eventOpened ? "" : "disabled"}`}
               // className={"disabled"}
                 onClick={eventOpened ?
                   () => this.goToStreaming(language) :
                   () => null}
               // onClick={() => null}
              >
                {buttonText}
              </button>
         
          </div>
        </div>
      </MsalAuthenticationTemplate>
    );
  }

  goToStreaming = (language: string) => {
    this.props.history.push(`/streaming/${language}`);
  };
}
